/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactHtmlParser from 'react-html-parser';
import  formatString  from './Helper/Helper';

const styles = (theme) => ({
    errorMsg: {
        margin: '0',
        textAlign: 'left',
        marginTop: '8px',
        minHeight: '1em',
        fontFamily: 'Roboto", "Helvetica", "Arial", sans-serif',
        lineHeight: '1em',
        color: theme.palette.error.main,
    },
    smallText: {
        fontSize: '0.75rem',
    },
    mediumText: {
        fontSize: '1.0rem',
    },
});

const InlineErrorMessage = ({ error, classes, fontSize }) => {
    const classFontSize  = (fontSize === 'medium') ? classes.mediumText : classes.smallText;
    return (
        <Typography
            align="left"
            variant="body2"
            className={`${classes.errorMsg} ${classFontSize}`}
        >
            { ReactHtmlParser(formatString(error)) }
        </Typography>
    );
};

InlineErrorMessage.propTypes = {
    error: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    fontSize: PropTypes.string,
};

InlineErrorMessage.defaultProps = {
    fontSize: 'small',
};

export default withStyles(styles)(InlineErrorMessage);
